import { Vue } from "vue-property-decorator";

const EventBus = new Vue();

export {
    EventBus
}
